module.exports = __webpack_public_path__ + "img/UN_Women_Spurning04.e336d8c2.gif";